export const MIN_LEN = 0;
export const FORM_LEN = 1;
export const JSON_STR_BASE = 2;
export const MILLISECONDS_PER_SECOND = 1000;
export const TWO_MINUTES_IN_MS = 120000;
export const FIFTEEN_SECONDS_IN_MS = 15000;
export const STR_MIN = 0;
export const STR_MAX = 2;
export const RECENT_ITEMS_LIMIT = 5;
export const REFRESH_TOKEN_KEY = 'refreshToken';

// `GET /v1/commands/:id` vocabulary. cqrs SDB-730 (dev, 2026-08-12) collapses the
// internal CommandStatus values into a client-facing trio: PROCESSING / COMPLETED /
// FAILED. Pre-SDB-730 environments (staging) still return the raw internal values,
// so both vocabularies are accepted during the rollout window. Drop the raw values
// once dev + staging are both on SDB-730.
export const POLLING_STATUS = {
  // Continue polling
  PROCESSING: 'PROCESSING',
  PENDING: 'PENDING',
  // cqrs SDB-727 renames FABRIC_UPDATED -> COMMAND_PROCESSED (commands can now be
  // processed by processors other than Fabric).
  FABRIC_UPDATED: 'FABRIC_UPDATED',
  COMMAND_PROCESSED: 'COMMAND_PROCESSED',

  // Stop polling - Success
  COMPLETED: 'COMPLETED',
  READ_STORE_UPDATED: 'READ_STORE_UPDATED',

  // Stop polling - Failure
  FAILED: 'FAILED',
  // cqrs SDB-727 renames ERROR_FABRIC -> ERROR_PROCESSOR (see note above).
  ERROR_FABRIC: 'ERROR_FABRIC',
  ERROR_PROCESSOR: 'ERROR_PROCESSOR',
  ERROR_SERVICE: 'ERROR_SERVICE',
  ERROR_BUS: 'ERROR_BUS',
} as const;

export const OTP_LENGTH = 6;
export const AUTO_PHONE_VERIFICATION_ORGANIZATION_ID = '';
export const AUTO_PHONE_VERIFICATION_CODE = '123456';
export const SESSION_TOKEN_KEY = 'sessionToken';
export const REGISTRATION_TOKEN_KEY = 'registrationToken';
export const REGISTRATION_STEP_KEY = 'registrationStep';
export const REGISTRATION_USERNAME_KEY = 'registrationUsername';
export const FIRST_INDEX = 0;
export const CREATE_SIX_NAME_MAX_LENGTH = 100;
export const CREATE_SIX_DESCRIPTION_MAX_LENGTH = 500;

export const DEBUG_PANEL_HOTKEY_KEY = '/';
export const DEBUG_PANEL_POLL_INTERVAL_MS = MILLISECONDS_PER_SECOND;
export const DEBUG_PANEL_DEFAULT_HEIGHT_PX = 280;
export const DEBUG_PANEL_MIN_HEIGHT_PX = 120;
export const LOG_BUFFER_CAPACITY = 1000;
export const P2P_PIN_COUNT_TTL_MS = 5000;
